// @ts-nocheck
import { CHEVRON_LEFT_16, SHARE_FILLED_16, CLOSE_16, USER_16 } from "@sznds/icons";
import { setItem, getItem } from "~/es6/localstorage";
import Header from "~/ui/header";
import createHeaderButton from "~/ui/headerbutton";
import dragNdrop from "~/dragNdrop";
import { watch, watchCurrentUser } from "~/state/util";
import { fragment, node, icon } from "~/util/dom";
import { createVerifiedUserTooltip } from "~/util/userweb";
import { sklikPhotoLike } from "~/util/sklik";
import { CONFIG } from "~/config";
import { setLike } from "~/util/providers/like";
import { buildStats } from "./stats";
import { _ } from "~/i18n";
import Map from "~/photo/components/map/map";
import MyMapsShare from "~/es6/mymaps.share";
import { createGalleryPIG } from "./pig";
import Resizer from "./resizer";
import Sorter from "./sorter";
import Scene from "~/scene";
import UploadButton from "~/photo/components/upload-button";
import PhotoContextMenu from "~/photo/components/contextmenu";
import { setGlobals, Provider, store, Canonical } from "~/photo/globals";
import { isDetailActive } from "~/util/detail";
import { setPoiGallery, clearPoiGallery } from "~/state/gallery/state";
import { IState } from "~/state/store";
import { ELoginState } from "~/state/user/interfaces";

const DEFAULT_PROPS = {
	type: "detail",
};
const OVERLAY_LOADER_CLASS = "overlay-loader";
const MAX_NUM_OF_FAIL_LOAD = 2;

function createLoader() {
	const loader = node("div", { className: "gallery-loader" });
	const img = node("img", { src: "/img/loader.gif", width: 24, height: 24 });
	const text = node("span", { innerHTML: _("loader") });

	loader.appendChild(img);
	loader.appendChild(text);

	return loader;
}

export function initModule(global) {
	setGlobals(global);
}

export default class Gallery {
	_node: HTMLDivElement;

	_cont: HTMLDivElement;

	_inner: HTMLDivElement;

	_headerCont: HTMLDivElement;

	_respoBlock: HTMLDivElement;

	_pigNode: HTMLDivElement;

	_printNode: HTMLDivElement;

	_overlayLoader: HTMLDivElement;

	_map: Map;

	_sorter: Sorter;

	_page: number;

	_headerHeight: number;

	_headerButtonsHeight: number;

	_photoContextMenu: PhotoContextMenu;

	_uploadButton: UploadButton;

	_resizer: Resizer;

	_lockLoad: boolean;

	_storeUnsubs: Array<() => void>;

	_header: Header;

	constructor(props) {
		this._storeUnsubs = [];
		this._props = {
			...DEFAULT_PROPS,
			...props,
		};
		this._node = node("div", { className: `gallery-container${CONFIG.isScreenshoter ? ` scrsht` : ``}` });
		this._cont = node("div", { className: "content" });
		this._inner = node("div");
		this._headerCont = node("div", { className: "gallery-header-container" });
		this._respoBlock = node("div", { className: "respo-block" });
		this._pigNode = node("div", { id: "pig" });
		this._printNode = node("div", { className: "pig-print" });
		this._pig = null;
		this._data = null;
		this._map = new Map("gallery-map", {
			showControls: true,
		});
		this._type = "poi";
		this._resizer = new Resizer({
			container: this._node,
			elements: [this._cont, this._map.node],
			steps: ["75%", "50%", 400, 0],
			reverse: true,
		});
		this._resizeObserver = null;
		this._resizeTimeout = null;
		this._header = null;
		this._headerHeight = 0;
		this._headerButtonsHeight = 0;
		this._mouseOut = null;
		this._lockLoad = false;
		this._page = 0;
		this._failLoadCounter = 0;

		this._sorter = new Sorter(this._props.sort);
		this._uploadButton = new UploadButton(this._props);
		this._photoContextMenu = new PhotoContextMenu();
		this._overlayLoader = node("div", { className: "overlay-loader-el" });
		const loaderImg = new Image();

		loaderImg.crossOrigin = "anonymous";
		loaderImg.src = "/img/loader.gif";
		this._overlayLoader.appendChild(loaderImg);
		this._cont.appendChild(this._inner);

		this._node.appendChild(this._map.node);
		this._node.appendChild(this._resizer.node);
		this._node.appendChild(this._cont);

		this._build();
		this._buildHeader();
	}

	destroy() {
		this._observerOff();

		this._clear();

		if (this._pig) {
			this._pig.disable();
			this._pig = null;
		}

		this._data = null;

		this._uploadButton.destroy();
		this._map.destroy();
		this._resizer.destroy();
		this._sorter.destroy();
		this._header.destroy();
	}

	get node() {
		return this._node;
	}

	get mapCenterZoom() {
		return this._map ? this._map.centerZoom : null;
	}

	get sort() {
		if (this._sorter) {
			return this._sorter.sort;
		}

		return "";
	}

	get logData() {
		let galleryType = "poi";

		const { user } = store.getState().user;
		const myGallery = user.userPublicId === this._props.id && user.state === "green";

		if (myGallery) {
			galleryType = "myMaps";
		} else if (this._props.source === "author") {
			galleryType = "user";
		}

		const ratioArr = [1, 0.75, 0.5, 0.25, 0];
		const actualStep = this._getRatio()-1;

		const data = {
			galleryType,
			section: "gallery",
			ratio: ratioArr[actualStep],
		};

		return data;
	}

	async reload(props) {
		this._props = {
			...DEFAULT_PROPS,
			...this._props,
			...props,
		};

		this._getViewType();

		if (this._data) {
			await this._build(this._data && this._data.error);

			if (this._props?.imgUrl && this._props.imgUrl !== "") {
				this._header.avatar = this._props.imgUrl;
			}

			if (this._props?.title && this._props.title !== "") {
				this._header.title = this._props.title;
			}

			if (this._props.source === "author" && this._data.gallery.length && this._data.author.galleryBbox) {
				const bbox = this._data.author.galleryBbox;
				const bl = SMap.Coords.fromWGS84(bbox.bottomLeft.lon, bbox.bottomLeft.lat);
				const tr = SMap.Coords.fromWGS84(bbox.topRight.lon, bbox.topRight.lat);

				this._coords = [bl, tr];
			} else {
				const { coords } = this._prepareData();

				this._coords = coords;
			}

			this._mapCenterZoom(this._props.coords || this._coords);

			this._setSEO();
		}
	}

	async handleEvent(event) {
		if (event.type === "width-change") {
			this._node.classList.remove(`step-${event.detail.prev}`);
			this._node.classList.add(`step-${event.detail.actual}`);

			try {
				let obj = {};
				const storage = getItem("gallery-ratio");

				obj[this._type] = event.detail.actual;

				if (storage) {
					obj = {
						...JSON.parse(storage),
						...obj,
					};
				}

				CONFIG?.printMode !== 3 && setItem("gallery-ratio", JSON.stringify(obj));
			} catch (ex) {
				// eslint-disable-next-line no-console
				console.log(ex);
			}

			if ((event.detail.actual !== 5 && event.detail.prev !== 5) || (Mapy.Util.isSmallResolution() && event.detail.actual !== 5)) {
				this._pigRedraw();
			}

			setTimeout(() => {
				this._map.sync();
			}, 200);
		} else if (event.type === "beforeprint") {
			this._printNode.innerHTML = this._pigNode.innerHTML;
		} else if (event.type === "afterprint") {
			this._printNode.innerHTML = "";
		} else if (event.type === "drag-start") {
			this._node.classList.add("drag");
		} else if (event.type === "drag") {
			const data = event.detail;

			if (data && "index" in data && "biggest" in data) {
				if ([4, 5].indexOf(data.index) === -1 || (data.index === 4 && !data.biggest)) {
					this._pigRedraw();
				}
			} else {
				this._pigRedraw();
			}
		} else if (event.type === "drag-end") {
			this._node.classList.remove("drag");
			if (!("index" in event.detail) || ("index" in event.detail && event.detail.index !== 5)) {
				this._pigRedraw();
			}
		} else if (event.type === "drop" && event.dataTransfer && event.dataTransfer.files) {
			event.preventDefault();
			event.stopPropagation();
			dragNdrop.test(
				event.dataTransfer.files,
				{
					photo: () => {
						const that = Mapy.getComponent("gallery")._gallery;

						that._cont.classList.add(OVERLAY_LOADER_CLASS);
						that._cont.appendChild(that._overlayLoader);
					},
				},
			);
		} else if (event.type === "sort") {
			this._sort(event.detail.type);
		} else if (event.type === "keydown" && event.keyCode === 27) {
			if (this._photoContextMenu.open) {
				this._photoContextMenu.close();
			} else {
				this.close();
				this._props.onClose && this._props.onClose();
			}
		} else if (event.type === "scroll") {
			if (event.target === this._cont) {
				this._header.compact = this._cont.scrollTop > 64;
			}

			if ("total" in this._data && this._data.total > this._data.gallery.length) {
				const limit = this._inner.offsetHeight - event.target.offsetHeight - (Mapy.Util.isSmallResolution() ? 400 : 700);

				if (event.target.scrollTop > limit && !this._lockLoad) {
					this._loadNextPage().then(() => {}, () => {});
				}
			}
		} else if (event.type === "mouseout" || event.type === "mouseover") {
			const hoverImg = this._pigNode.querySelector(`figure.hover`);
			const figure = event.target.closest("figure");

			if (figure) {
				const source = figure.dataset.source;
				const id = parseFloat(figure.dataset.id);

				if (hoverImg) {
					hoverImg.classList.remove("hover");
				}

				if (event.type === "mouseout") {
					this._mouseOut = {
						source,
						id,
						timeout: setTimeout(() => {
							this._map.hoverMarker();
							this._mouseOut = null;
						}, 50),
					};
				} else if (this._mouseOut && this._mouseOut.id === id && this._mouseOut.source === source) {
					clearTimeout(this._mouseOut.timeout);
					this._mouseOut = null;
				} else {
					if (this._mouseOut) {
						clearTimeout(this._mouseOut.timeout);
						this._mouseOut = null;
					}

					this._map.hoverMarker(
						source,
						id,
						this._getItemData(source, id),
					);
				}
			}
		} else if (event.type === "marker-click") {
			const data = event.detail;

			if (data && data.source && data.id) {
				this._openDetail(data.source, data.id);
			}
		} else if (event.type === "marker-enter" || event.type === "marker-leave") {
			const data = event.detail;
			const hoverImg = this._pigNode.querySelector(`figure.hover`);
			const img = this._pigNode.querySelector(`figure[data-id="${data.id}"][data-source="${data.source}"]`);

			if (hoverImg) {
				hoverImg.classList.remove("hover");
				this._map.hoverMarker();
			}

			if (img && event.type === "marker-enter") {
				img.classList.add("hover");
			}
		} else if (event.type === "best-fit") {
			this._mapCenterZoom(this._coords);
		} else if (event.type === "photo-delete") {
			const source = event.detail.source;
			const id = event.detail.id;
			let photo = null;

			for (let index = 0; index < this._data.gallery.length; index++) {
				photo = this._data.gallery[index];

				if (photo.source === source && photo.id === id) {
					this._data.gallery.splice(index, 1);

					break;
				}
			}

			if (this._pig) {
				for (let index = 0; index < this._pig.images.length; index++) {
					const image = this._pig.images[index];

					if (image.data.id === id && image.data.source === source) {
						this._pig.images.splice(index, 1);

						break;
					}
				}

				this._pig.disable();
				this._pigNode.innerHTML = "";
				this._pig.enable();

				requestAnimationFrame(() => {
					this._pigRedraw();
				});
			}

			/*if (this._data.author) {
				this._data.author.viewCount = Math.max(0, this._data.author.viewCount - 1);
				this._data.author.likeSum = Math.max(0, this._data.author.likeSum - 1);
				this._data.author.mediaCount = Math.max(0, this._data.author.mediaCount - 1);
				this._data.total = Math.max(0, this._data.total - 1);
			}*/

			if (this._data?.author) {
				const stats = await Provider.getStats(this._data.author.userPublicId);

				this._buildStats(stats.author);
			}

			this._props.onClose && this._props.onClose("photo-delete", {
				source,
				id,
			});
		} else if (event.type === "click" && (event.target === this._respoBlock || this._respoBlock.contains(event.target))) {
			if (this._node.classList.contains("step-4")) {
				this._resizer.set(3);
			} else {
				this._resizer.set(4);
			}
		} else if (event.type === "like-change") {
			if (event.detail.id && event.detail.source) {
				const item = this._getItemData(event.detail.source, event.detail.id);

				if (item) {
					const figure = this._pigNode.querySelector(`figure[data-id="${item.id}"][data-source="${item.source}"]`);

					if (figure) {
						const likeButton = figure.querySelector("button.like-button");
						const italic = likeButton ? likeButton.querySelector("i") : null;

						if (likeButton) {
							likeButton.classList.remove("liked");
							likeButton.classList[event.detail.likes.voted ? "add" : "remove"]("liked");
						}

						if (italic) {
							italic.innerText = event.detail.likes.count;
						}

						Provider.clear(this._props.source, this._props.id);

						item.likes.count = event.detail.likes.count;
						item.likes.voted = event.detail.likes.voted;
					}
				}
			}
		} else if (!this._photoContextMenu.open) {
			const figure = event.target.closest("figure");

			// pokud by bylo zadouci zastavit klik aby nedosel az na klik na fotku i pro klik do figcaption obecne, tak staci stopPropagation i pro target.tagName == "figcaption" a cokoliv v nem
			if ((figure && event.target.classList.contains("icon-etc-vertical")) || event.target.closest("svg.icon-etc-vertical")) {
				const elm = event.target.classList.contains("icon-etc-vertical") ? event.target : event.target.closest("svg.icon-etc-vertical");
				const bb = elm.getBoundingClientRect();
				const pigbb = this._pig ? this._pig.container.getBoundingClientRect() : { top: 0, left: 0 };
				const item = this._getItemData(figure.dataset.source, figure.dataset.id);

				if (item) {
					const { user } = store.getState().user;
					const myGallery = user.userPublicId === this._props.id && user.state === "green";

					this._photoContextMenu.data = {
						id: item.id,
						source: item.source,
						userPublicId: this._props.source === "author" ? this._props.id : item.userPublicId,
						detail: false,
						title: item.name,
						coords: item.mark,
						url: item.urls[0].url,
						url300: Mapy.CDN.setSize(item.urls[1].url, Mapy.CDN.SIZE_400_400, false),
						my: myGallery,
						review: !!(item.review || item.reviewId),
						approved: item.approved,
						poi: this._props.detail
							? {
								id: this._props.id,
								source: this._props.source,
							}
							: null,
					};

					const left = bb.left - pigbb.left;

					this._photoContextMenu.node.style.top = `${bb.top - pigbb.top}px`;
					this._photoContextMenu.node.style.left = `${left < 120 ? 120 : left}px`;

					if (this._pig) {
						this._pig.container.appendChild(this._photoContextMenu.node);
					}
				}

				event.stopPropagation();
			} else if ((figure && event.target.classList.contains("like-button")) || event.target.closest("button.like-button")) {
				if (event.type !== "keydown") {
					let promise = Promise.resolve();
					const item = this._getItemData(figure.dataset.source, figure.dataset.id);
					const { user } = store.getState().user;

					if (user.state !== "green") {
						promise = Mapy.getComponent("login").open({
							analyticsData: {
								loginOrigin: "photoLike",
								section: "reviews",
							},
							motivation: "like",
						});
					}

					promise.then(() => {
						const elm = event.target.classList.contains("like-button") ? event.target : event.target.closest("button.like-button");
						const like = !(elm.classList.contains("like") || elm.classList.contains("liked"));

						sklikPhotoLike();
						setLike(item.likes.id, like).then(res => {
							if (res) {
								const italic = elm.querySelector("i");

								elm.classList.remove("liked");

								if (italic) {
									italic.innerText = res.data.count;
								}

								elm.classList[res.data.voted ? "add" : "remove"]("like");

								// pokud bude nekdo skrolovat galerii a pak se tam element zase vlozi, doslo by k opetovne animaci
								window.setTimeout(() => {
									if (elm.classList.contains("like")) {
										elm.classList.add("liked");
										elm.classList.remove("like");
									}
								}, 3500);

								Provider.clear(item.source, item.id);
								Provider.clear(this._props.source, this._props.id);

								item.likes.count = res.data.count;
								item.likes.voted = res.data.voted;

								const logData = {
									origin: "photos",
									type: res.data.voted ? "like" : "dislike",
									id: item.source === "index" ? item.urls[0].url : item.id,
									source: item.source === "index" ? "booking" : item.source,
								};

								this._log({
									origin: "photos",
									text: "heart-button",
									...logData,
								});
							}
						}, () => {});
					}, () => {});

					event.stopPropagation();
				}
			} else if (figure) {
				this._openDetail(figure.dataset.source, figure.dataset.id);
			}
		}
	}

	async open() {
		this._getViewType();
		const ratio = this._getRatio();

		Mapy.getComponent("loader").start();

		this._node.addEventListener("drop", this, false);

		this._resizer.node.addEventListener("width-change", this, false);
		this._resizer.node.addEventListener("drag-start", this, false);
		this._resizer.node.addEventListener("drag", this, false);
		this._resizer.node.addEventListener("drag-end", this, false);
		this._resizer.set(ratio);

		this._sorter.node.addEventListener("sort", this, false);

		this._pigNode.addEventListener("click", this, false);
		this._pigNode.addEventListener("mouseover", this, false);
		this._pigNode.addEventListener("mouseout", this, false);

		this._map.node.addEventListener("marker-click", this, false);
		this._map.node.addEventListener("marker-enter", this, false);
		this._map.node.addEventListener("marker-leave", this, false);
		this._map.node.addEventListener("best-fit", this, false);

		this._photoContextMenu.node.addEventListener("photo-delete", this, false);

		this._respoBlock.addEventListener("click", this, false);

		if (this._props.source !== "osm" && this._props.source !== "firm") {
			this._node.addEventListener("scroll", this, false);
		}
		this._cont.addEventListener("scroll", this, false);

		const userWatcher = watch(store.getState, "user", watchCurrentUser);
		const unsubUser = store.subscribe(userWatcher(userState => {
			const reload = async () => {
				this._data = null;
				this._build();

				Provider.clear(this._props.source, this._props.id);
				this._clearPig();

				if (Mapy.getComponent("photoDetail").isActive()) {
					const state = Mapy.getComponent("photoDetail").getState();

					this._props.photo = {
						source: state.sourcep,
						id: state.idp,
					};
				}

				this._node.classList.remove("scroll");
				await this._load();

				if (this._type !== "poi") {
					this._updateHeader(userState.user);
				}
			};

			if (this._props.source === "author") {
				reload();
			}
		}));

		const galleryWatcher = watch(store.getState, "gallery");
		const unsubGallery = store.subscribe(galleryWatcher((newState: IState["gallery"]) => {
			const clear = newState.poiGalleryInd <= 0;

			this._map.addMarkers(newState.poiGallery, clear);
		}));

		this._storeUnsubs.push(unsubUser);
		this._storeUnsubs.push(unsubGallery);

		window.addEventListener("beforeprint", this, false);
		window.addEventListener("afterprint", this, false);

		document.body.classList.add("gallery-list");

		document.body.appendChild(this._node);

		//# MAPA
		this._map.sync();

		this._mapCenterZoom();
		//#- MAPA

		if (window.ResizeObserver) {
			this._observerOff();

			this._resizeObserver = new ResizeObserver(() => {
				this._resizer.set(this._getRatio());

				this._resizeTimeout = null;
			});

			this._resizeObserver.observe(this._node);
		}

		window.addEventListener("keydown", this, false);

		await this._load();
		this._updateHeader(store.getState().user.user);
	}

	close() {
		this._observerOff();

		this._node.removeEventListener("drop", this, false);

		this._node.remove();
		this._resizer.node.removeEventListener("width-change", this, false);
		this._resizer.node.removeEventListener("drag-start", this, false);
		this._resizer.node.removeEventListener("drag", this, false);
		this._resizer.node.removeEventListener("drag-end", this, false);

		this._sorter.node.removeEventListener("sort", this, false);

		this._pigNode.removeEventListener("click", this, false);
		this._pigNode.removeEventListener("mouseover", this, false);
		this._pigNode.removeEventListener("mouseout", this, false);

		this._map.node.removeEventListener("marker-click", this, false);
		this._map.node.removeEventListener("marker-enter", this, false);
		this._map.node.removeEventListener("marker-leave", this, false);
		this._map.node.removeEventListener("best-fit", this, false);

		this._photoContextMenu.node.removeEventListener("photo-delete", this, false);

		this._respoBlock.removeEventListener("click", this, false);

		if (this._props.source !== "osm" && this._props.source !== "firm") {
			this._node.removeEventListener("scroll", this, false);
		}
		this._cont.removeEventListener("scroll", this, false);

		this._storeUnsubs.forEach(unsub => unsub());

		window.removeEventListener("beforeprint", this, false);
		window.removeEventListener("afterprint", this, false);

		document.body.classList.remove("gallery-list");

		window.removeEventListener("keydown", this, false);
		store.dispatch(clearPoiGallery());
	}

	loadNextPage() {
		return this._loadNextPage().then(() => this._data.gallery, () => {});
	}

	_load() {
		return new Promise((resolve, reject) => {
			if (this._props.source && this._props.id) {
				let sort = this._props.sort ? this._props.sort : this._sorter.getDefaultSort("poi");

				if (this._props.source === "author") {
					sort = this._props.sort ? sort : this._sorter.getDefaultSort("author");
					this._sorter.setType(sort, "author");

					const { user } = store.getState().user;

					if (user.userPublicId === this._props.id && user.state === "green") {
						sort = this._props.sort ? sort : this._sorter.getDefaultSort("my");
						this._sorter.setType(sort, "my");
						// pokud koukam na svoji galerii, tak se to loguje, jako bych byl v Moje Mapy
						Mapy.getComponent("logger").log("view", { text: "photos" });
					}
				} else if (this._props.sort) {
					this._sorter.setType(sort, "poi");
				}

				Provider.list({
					source: this._props.source,
					id: this._props.id,
					sortType: sort,
					beatyScore: Mapy.CUS.userweb?.photoBeautyScore,
				}).then(async res => {
					if (Mapy.getComponent("gallery").isActive()) {
						if (res.error) {
							this._data = {
								error: true,
							};
							await this._build(true);

							Mapy.getComponent("loader").end();
						} else {
							this._data = JSON.parse(JSON.stringify(res));

							if (this._props.source === "author" && res.author.userSource === "rus") {
								if (res.author?.avatarUrl) {
									this._props.imgUrl = `${res.author.avatarUrl}/96`;
								}
							}

							this._processData();

							Mapy.getComponent("loader").end();
						}

						resolve();
					} else {
						reject();
					}
				}, () => {
					reject();
				});
			}
		});
	}

	_loadNextPage() {
		if (this._failLoadCounter >= MAX_NUM_OF_FAIL_LOAD) {
			return Promise.reject();
		}

		this._lockLoad = true;
		Mapy.getComponent("loader").start();
		this._page++;

		const loader = createLoader();

		loader.classList.add("page-load");
		this._pigNode.after(loader);

		let type = this._props.source === "author" ? "author" : "poi";

		const { user } = store.getState().user;
		const myGallery = user.userPublicId === this._props.id && user.state === "green";

		if (myGallery) {
			type = "my";
		}

		let sort = this._sorter.sort;

		if (sort === "") {
			sort = this._sorter.getDefaultSort(type);
		}

		return Provider.list({
			source: this._props.source,
			id: this._props.id,
			sortType: sort,
			page: this._page,
			beatyScore: Mapy.CUS.userweb?.photoBeautyScore,
		}).then(res => {
			if (Mapy.getComponent("gallery").isActive()) {
				if (res.error || !res.gallery.length) {
					this._failLoadCounter++;
					this._page--;
				} else {
					const data = JSON.parse(JSON.stringify(res));

					this._data.gallery = this._data.gallery.concat(data.gallery);
					this._data.total = data.total;

					this._callSetPoiGallery();

					const { galleryData } = this._prepareData();

					this._pig.disable();
					this._pigNode.innerHTML = "";
					this._pig.images = this._pig.images.concat(this._pig.createImageData(galleryData.slice(this._page * Provider.ITEM_ON_PAGE, (this._page * Provider.ITEM_ON_PAGE) + Provider.ITEM_ON_PAGE)));
					this._pig.enable();

					requestAnimationFrame(() => {
						this._pigRedraw();
					});

					this._failLoadCounter = 0;
				}

				Mapy.getComponent("loader").end();
				this._lockLoad = false;
				loader.remove();
			}
		}, () => {
			this._page--;
			this._lockLoad = false;
			this._failLoadCounter++;
			loader.remove();
		});
	}

	_callSetPoiGallery() {
		if (this._props.source === "firm") {
			const poiGallery = this._data.gallery.map(item => ({
				...item,
				image: {
					...item.image,
				},
			}));
			const poiGalleryInd = this._page * Provider.ITEM_ON_PAGE;

			store.dispatch(setPoiGallery({
				poiGallery,
				poiGalleryInd,
			}));
		}
	}

	_processData() {
		if (this._props.source === "author") {
			this._props.title = this._data.author.name;
		}

		this._callSetPoiGallery();
		this._build();

		if (this._data.gallery.length) {
			const { galleryData, coords } = this._prepareData();

			this._coords = coords;

			if (CONFIG?.printMode === 3) {
				const img = node("img", { src: Mapy.CDN.setSize(galleryData[0].filename, Mapy.CDN.SIZE_400_400, false, false), crossOrigin: "anonymous" });

				this._cont.append(img);
			} else {
				this._pig = createGalleryPIG(this._pigNode, galleryData, Mapy.Util.isSmallResolution() ? this._node : this._cont, {
					resizer: this._resizer,
					viewCount: this._sorter.sort === "viewCount",
				});
			}

			if (this._pig) {
				this._pig.enable();
			}

			// pokud nam prisel detail fotky, pokusime se ji otevrit
			if (this._props.photo) {
				this._openDetail(this._props.photo.source, this._props.photo.id, !this._props.photo.forceHistorySave);

				delete this._props.photo;
			} else if (Mapy.getComponent("photoDetail").isActive()) {
				Mapy.getComponent("photoDetail").close();
			}

			if (this._props.coords) {
				this._mapCenterZoom(this._props.coords);
			} else if (coords.length) {
				this._mapCenterZoom(coords);
			} else if (this._props.source === "author" && this._data.gallery.length && this._data.author.galleryBbox) {
				const bbox = this._data.author.galleryBbox;
				const bl = SMap.Coords.fromWGS84(bbox.bottomLeft.lon, bbox.bottomLeft.lat);
				const tr = SMap.Coords.fromWGS84(bbox.topRight.lon, bbox.topRight.lat);

				this._mapCenterZoom([bl, tr]);
			}

			this._setSEO();
		}
	}

	_getViewType() {
		if (this._props.source === "author") {
			this._type = "author";

			const { user } = store.getState().user;

			if (user.userPublicId === this._props.id && user.state === ELoginState.Green) {
				this._type = "my";
			}
		}
	}

	_observerOff() {
		if (this._resizeObserver) {
			this._resizeObserver.unobserve(this._map.node);
			this._resizeObserver = null;
		}
	}

	_pigRedraw() {
		if (this._pig) {
			const viewCount = this._sorter.sort === "viewCount";

			this._pig.disable();
			this._pig.scroller = Mapy.Util.isSmallResolution() ? this._node : this._cont;
			this._pig.enable();

			if (this._photoContextMenu.open) {
				this._photoContextMenu.close();
			}

			for (let index = 0; index < this._pig.images.length; index++) {
				const image = this._pig.images[index];

				requestAnimationFrame(() => {
					image.element.classList.remove("date-dn");
					image.element.classList.remove("title-dn");

					let date = true;
					let title = true;

					if (image.style.width < 125 && (viewCount && !image.data.viewCount)) {
						date = false;
					} else if (image.style.width < 180) {
						date = false;
					}

					if (image.style.width < 212 && (viewCount && !image.data.viewCount)) {
						title = false;
					} else if (image.style.width < 274) {
						title = false;
					}

					if (!date) {
						image.element.classList.add("date-dn");
					} else if (!title) {
						image.element.classList.add("title-dn");
					}
				});
			}
		}
	}

	_clear() {
		this._inner.innerHTML = "";
		this._pigNode.innerHTML = "";
		this._cont.classList.remove("empty");
		this._cont.classList.remove("author");
		this._cont.classList.remove("my");

		this._pigNode.style.height = "";
	}

	_clearPig() {
		if (this._pig) {
			this._pig.disable();
			this._pig = null;
		}

		this._pigNode.innerHTML = "";
		this._pigNode.style.height = "";
	}

	_buildHeader() {
		this._header = new Header({
			avatar: this._props?.imgUrl && this._props?.imgUrl !== ""
				? this._props.imgUrl
				: this._data?.gallery?.length && this._data.gallery[0].urls && this._data.gallery[0].urls["1x1"]
					? Mapy.CDN.setSize(this._data.gallery[0].urls["1x1"], Mapy.CDN.SIZE_112_112)
					: icon("avatar"),
		});

		this._headerCont.innerHTML = "";
		this._headerCont.appendChild(this._header.node);
	}

	_updateHeader(userData) {
		const myGallery = userData.userPublicId === this._props.id && userData.state === "green";
		const frag = fragment();

		frag.appendChild(node("div", { className: "ui-header__gallery-title" }, myGallery ? _("gallery.titleMy") : this._props.title ? this._props.title : "..."));

		if (!myGallery && this._props.source === "author" && this._data?.author?.bankId) {
			const verifiedIcon = icon("verifieduser24");

			verifiedIcon.classList.add("ui-header__gallery-icon");
			frag.appendChild(verifiedIcon);
			createVerifiedUserTooltip(verifiedIcon);
		}

		this._header.title = frag;
		if (this._props.source === "author") {
			this._header.premium = this._data?.author?.hasPremium ? "mapy" : "none";
		}

		this._header.leftButtons.innerHTML = "";
		this._header.rightButtons.innerHTML = "";

		const backToMyDashoboard = myGallery && Mapy.active[0] === Mapy.getComponent("mymaps");
		const backButton = createHeaderButton({
			icon: backToMyDashoboard ? CHEVRON_LEFT_16 : CLOSE_16,
			innerHTML: backToMyDashoboard ? _("mymap.stateswitch") : _("close"),
		});

		Mapy.active[0] === Mapy.getComponent("userProfile") && backButton.setAttribute("data-log-publicProfile", "1");
		// spinavy trik - pokud je to moje galerie, je aktivni MM a neni aktivni detail, tak se zavrenim dostavame fakt do dashboardu a jinak to nepozname
		backToMyDashoboard && backButton.setAttribute("data-log-text", "backToDashboard");
		backButton.addEventListener("click", () => {
			// spinavy trik - pokud je to moje galerie, je aktivni MM a neni aktivni detail, tak se zavrenim dostavame fakt do dashboardu, ten je ale ve skutecnosti celou dobu aktivni pod galerii, takze musime jeho view zavolat tady
			if (backToMyDashoboard) {
				if (Mapy.getComponent("mymaps").isActive() && !isDetailActive(store.getState())) {
					Mapy.getComponent("logger").log("view", { text: "dashboard" });
				}
				this.close();
			}

			this._props.onClose && this._props.onClose();

			!backToMyDashoboard && setTimeout(() => {
				Mapy.getComponent("history").save(true);
			}, 0);
		});
		this._header.leftButtons.appendChild(backButton);

		if (!myGallery && this._props.source === "author") {
			const state = Mapy.getComponent("userProfile").getState();
			const singleButton = Mapy.getComponent("userProfile").isActive() && "up" in state && state.up === this._props.id;

			// pokud je aktivni verejny profil a je to profil stejneho uzivatele, chceme jen jedno a to jine tlacitko
			singleButton && backButton.remove();

			if (this._props.id) {
				const profileButton = createHeaderButton({
					icon: singleButton ? CHEVRON_LEFT_16 : USER_16,
					innerHTML: _("userProfile.userContributions"),
				});

				Mapy.active[0] === Mapy.getComponent("userProfile") && profileButton.setAttribute("data-log-publicProfile", "1");
				profileButton.addEventListener("click", () => {
					Mapy.getComponent("userProfile").activate();
					Mapy.getComponent("userProfile").setState({ up: this._props.id });
					this._props.onClose && this._props.onClose();
					setTimeout(() => {
						Mapy.getComponent("history").save(true);
					}, 0);
				});
				this._header.leftButtons.appendChild(profileButton);
			}
		}

		// upload
		if (!this._props.hideUploadButton && (myGallery || this._type === "poi")) {
			const uploadButton = createHeaderButton({
				icon: "add-photo2",
				innerHTML: _("gallery.uploadPhoto"),
			});

			uploadButton.setAttribute("data-log-ignore", "1");
			uploadButton.addEventListener("click", () => {
				const { longitude, latitude } = store.getState().map;
				const coords = Scene.coordsFromWGS84(longitude, latitude);
				const poi = {
					source: this._props.source === "author" ? Mapy.ImageUploader.NO_POI_SOURCE : this._props.source,
					id: this._props.id ? this._props.id : coords.toWGS84(2).reverse().join(", "),
				};

				let type = this._props.source === "coor" ? "coor" : "poi";

				if (this._props.coords) {
					poi.mark = this._props.coords;
				}

				if (this._props.source === "author") {
					type = "empty";
				}

				const galleryLogData = Mapy.getComponent("gallery").logData;

				Mapy.getComponent("logger").log("click", Object.assign(galleryLogData, {
					origin: "fotky",
					text: _("gallery.uploadPhoto"),
					type: galleryLogData.galleryType === "poi" ? "poi" : "empty",
					source: galleryLogData.galleryType === "poi" ? "mapy-gallery" : "mapy-my_maps",
				}));

				const param = {
					poi,
					source: galleryLogData.galleryType === "poi" ? "mapy-gallery" : "mapy-my_maps",
					type,
				};

				const { user } = store.getState().user;

				if (user.state === "green") {
					Mapy.getComponent("imageUploader").activate().setData(param);
				} else {
					Mapy.getComponent("login").open({
						analyticsData: {
							loginOrigin: "photoUpload",
						},
						motivation: "photo",
					}).then(() => {
						Mapy.getComponent("imageUploader").activate().setData(param);
					}, () => {});
				}
			});
			this._header.rightButtons.appendChild(uploadButton);
		}

		// sdileni
		const shareButton = createHeaderButton({
			icon: SHARE_FILLED_16,
			innerHTML: _("mymap.contextMenu.share"),
		});

		shareButton.setAttribute("data-log-ignore", "1");
		this._header.rightButtons.appendChild(shareButton);
		shareButton.addEventListener("click", () => {
			const data = {
				title: `${_("gallery.share.gallery")}${this._props.title && this._props.title !== "" ? ` - ${this._props.title}` : ``}`,
				type: "gallery",
				myGallery: myGallery,
				noFrame: true,
			};
			let sharePopup = new MyMapsShare(data, () => {
				sharePopup.destroy();
				sharePopup = null;
			});

			sharePopup.open();

			Mapy.getComponent("logger").log("click", Object.assign(Mapy.getComponent("gallery").logData, {
				text: _("action.share.title"),
			}));
		});

		if (this._props?.imgUrl) {
			this._header.avatar = this._props.imgUrl;
		}
	}

	_build(error = false) {
		this._clear();

		this._cont.classList.remove("load");

		this._node.classList.add("gallery-container2");
		this._inner.appendChild(this._headerCont);

		const bottom = node("div", { className: "bottom-part" });
		const bottomContent = node("div");
		const logo = node("a", { className: "logo logo-mapycom", href: "/" });
		const bottomPart = node("p", {}, _("gallery.bottomPart"));

		logo.append(icon("logo"));

		if (this._data && this._data.gallery) {
			this._buildStats(this._props.source === "author"
				? this._data.author
				: {
					mediaCount: "total" in this._data ? this._data.total : this._data.gallery.length,
				});

			if (this._props.source !== "author" && !this._props.hideUploadButton) {
				bottomContent.appendChild(bottomPart);
				bottomContent.appendChild(this._uploadButton.node);
			} else {
				const { user } = store.getState().user;
				const myGallery = user.userPublicId === this._props.id && user.state === "green";

				if (myGallery) {
					bottomPart.innerHTML = _("gallery.bottomPartAuthor");

					bottomContent.insertBefore(this._uploadButton.node, bottomContent.firstChild);
					bottomContent.insertBefore(bottomPart, bottomContent.firstChild);

					this._cont.classList.add("my");
				} else {
					this._cont.classList.add("author");
				}
			}

			if (!this._data.gallery.length) {
				if (this._data.author?.userPublicId === "") {
					bottomPart.innerHTML = _("gallery.bottomPartUserNotFound");
					bottomContent.appendChild(bottomPart);
					this._cont.classList.add("empty");
				} else {
					bottomPart.innerHTML = _("gallery.bottomPartForeign");
					bottomContent.appendChild(bottomPart);
					bottomContent.appendChild(node("img", { src: "/img/mymap/empty-photos.svg" }));
					this._cont.classList.add("empty");
				}
			}

			bottom.appendChild(bottomContent);

			this._inner.appendChild(this._pigNode);
			this._inner.appendChild(this._printNode);
		} else {
			this._cont.classList.add("load");

			if (error) {
				const errorElm = node("p", { className: "error" }, _("gallery.loadError"));

				if (this._props.source !== "author" && !this._props.hideUploadButton) {
					bottomContent.appendChild(bottomPart);
					bottomContent.appendChild(this._uploadButton.node);
				} else {
					const { user } = store.getState().user;

					if (user.userPublicId === this._props.id) {
						bottomContent.appendChild(this._uploadButton.node);
					}
				}

				bottom.appendChild(bottomContent);

				this._inner.appendChild(errorElm);
			} else {
				this._inner.appendChild(createLoader());
			}
		}

		bottom.appendChild(logo);

		this._inner.appendChild(bottom);

		requestAnimationFrame(() => {
			this._pigRedraw();
			const buttons = this._header?.node.querySelector(".buttons");

			this._headerButtonsHeight = buttons ? buttons.offsetHeight : 0;
			this._headerHeight = this._header?.node.offsetHeight || 0;
		});

		if (this._data && this._data.gallery && this._data.gallery.length) {
			if (this._props.source === "author") {
				const { user } = store.getState().user;
				const myGallery = user.userPublicId === this._props.id && user.state === "green";

				this._map.userPublicId = this._props.id;
				this._map.my = myGallery;
			} else {
				this._map.POI = {
					source: this._props.source,
					id: this._props.id,
				};
			}
		}

		if (this._props.detail && this._props.detail.coords) {
			this._map.detailMarker = this._props.detail;
		}

		this._node.appendChild(this._respoBlock);
	}

	_prepareData() {
		const coords = [];
		let galleryData = [];

		if (this._props.detail && this._props.detail.coords) {
			coords.push(SMap.Coords.fromWGS84(this._props.detail.coords[0], this._props.detail.coords[1]));
		}

		if (this._data.gallery && this._data.gallery.length) {
			let noSourceIndex = 0;

			for (let index = 0; index < this._data.gallery.length; index++) {
				const image = this._data.gallery[index];

				if (image.id === 0) {
					noSourceIndex++;
					image.source = "index";
					image.id = noSourceIndex;
				}
			}

			galleryData = this._data.gallery.map(image => {
				let filename = image.urls[0].url;
				const placeholder = image.urls.filter(url => url.urlType === "placeholder");

				if (placeholder.length) {
					filename = placeholder[0].url;
				}

				const ratio = image.width/image.height;
				const date = image.date ? new Date(image.date) : null;
				let title = date ? Mapy.Util.dateToLocaleFormatLocal(date) : "";
				const name = `${title}${title !== "" && image.name !== "" ? ` • ` : ``}${image.name === "" ? `` : `${Mapy.Util.escapeTags(image.name)}`}`;

				if (ratio > 0.9 && image.name !== "") {
					if (title === "") {
						title += "<i>";
					} else {
						title += "<i>&nbsp;•&nbsp;";
					}

					title += `<b>${Mapy.Util.escapeTags(image.name)}</b></i>`;
				}

				coords.push(SMap.Coords.fromWGS84(image.mark.lon, image.mark.lat));

				return {
					filename,
					aspectRatio: ratio,
					title: title,
					name: name,
					id: image.id,
					source: image.source,
					likeCount: image.likes && image.likes.count ? image.likes.count : 0,
					like: image.likes && image.likes.voted ? image.likes.voted : false,
					viewCount: image.viewCount,
					approved: image.approved,
					beautyScore: image.beautyScore || 0,
				};
			});
		}

		return { galleryData, coords };
	}

	_sort(type) {
		const galleryData = this._data.gallery;
		let promise = Promise.resolve();
		const galleryLen = this._data.gallery.length;
		let postProccess = arr => {
			this._data.gallery = [];

			if (arr.length) {
				for (let index = 0; index < arr.length; index++) {
					const photo = arr[index];

					for (let dataIndex = 0; dataIndex < galleryData.length; dataIndex++) {
						const gData = galleryData[dataIndex];

						if (photo.likes.id === gData.likes.id) {
							this._data.gallery.push(Object.assign(photo, gData));

							break;
						}
					}
				}
			}
		};

		Mapy.getComponent("loader").start();

		delete this._data.gallery;

		this._clearPig();

		this._build();

		if (galleryLen !== this._data.author?.mediaCount || this._page !== 0) {
			promise = Provider.list({
				source: this._props.source,
				id: this._props.id,
				sortType: type,
				beatyScore: Mapy.CUS.userweb?.photoBeautyScore,
			});

			postProccess = arr => {
				this._data.gallery = arr;
			};
		} else {
			promise = Provider.sort({
				source: this._props.source,
				id: this._props.id,
				sortType: type,
			});
		}

		this._page = 0;

		promise.then(res => {
			if (Mapy.getComponent("gallery").isActive()) {
				if (res.error) {
					this._data = {
						error: true,
					};

					this._build(true);
				} else {
					const arr = JSON.parse(JSON.stringify(res.gallery));

					postProccess(arr);

					this._sorter.setType(type);

					this._processData();
				}

				Mapy.getComponent("loader").end();
				Mapy.getComponent("history").save();
			}
		}, () => {});
	}

	_openDetail(source, id, fromHistory) {
		if (Mapy.getComponent("photoDetail").isActive()) {
			Mapy.getComponent("photoDetail").close();
		}

		const { user } = store.getState().user;
		const myGallery = user.userPublicId === this._props.id && user.state === "green";

		Mapy.getComponent("photoDetail").setData({
			source: source,
			id: id,
			list: this._data.gallery,
			detail: this._props.detail ? this._props.detail : null,
			count: this._data.total ?? this._data.gallery.length,
			activeLayer: this._map.activeLayer,
			my: myGallery,
			poi: this._props.detail
				? {
					id: this._props.id,
					source: this._props.source,
				}
				: null,
			onClose: (type, data) => {
				if (type === "close-map-click" && data && data.source && data.id) {
					this._selectItem(data.source, data.id);

					if (data.mark) {
						this._map.centerZoom = {
							coords: [data.mark.lon, data.mark.lat],
							zoom: 20,
						};
					}

					this._map.showBestFitControl();
				}

				this._node.removeEventListener("like-change", this, false);

				this._map.controlKeyboard(true);
				window.addEventListener("keydown", this, false);

				this._setSEO();
			},
		}).activate();

		this._node.addEventListener("like-change", this, false);

		this._map.controlKeyboard(false);
		window.removeEventListener("keydown", this, false);

		const historyState = Mapy.getComponent("history").state;

		if (!fromHistory || (fromHistory && (historyState.sourcep !== source || historyState.idp !== id))) {
			Mapy.getComponent("history").save();
		}
	}

	_mapCenterZoom(coords = []) {
		const centerZoom = this._map.computeCenterZoom(coords, true);

		if (centerZoom && centerZoom[0].x && centerZoom[1] > 0) {
			const center = [centerZoom[0].x, centerZoom[0].y];
			let zoom = 17;

			if (centerZoom[1] > 0 && centerZoom[1] < 17) {
				zoom = centerZoom[1];
			}

			this._map.centerZoom = {
				coords: center,
				zoom,
			};
		}
	}

	_selectItem(source, id) {
		if (this._pig) {
			// zascrollovat
			const images = this._pig.images;
			let inList = false;

			for (let index = 0; index < images.length; index++) {
				const img = images[index];

				if (img.data.source === source && img.data.id === id) {
					const headerStyle = window.getComputedStyle(this._header.node);
					const height = parseInt(headerStyle.height) || 0;
					const marginTop = parseInt(headerStyle.marginTop) || 0;

					inList = true;
					this._cont.scroll(0, Math.round(img.style.translateY + height + marginTop));
				}
			}
			// #zascrolovat

			if (inList) {
				const item = this._pigNode.querySelector(`figure[data-id="${id}"][data-source="${source}"]`);
				const selectItem = sItem => {
					sItem.classList.add("hover");
					this._map.hoverMarker(source, id, this._props.source === "author" ? this._getItemData(source, id) : null);
				};

				if (item) {
					selectItem(item);
				} else {
					const observer = new MutationObserver(() => {
						const itemElm = this._pigNode.querySelector(`figure[data-id="${id}"][data-source="${source}"]`);

						if (itemElm) {
							selectItem(itemElm);

							observer.disconnect();
						}
					});

					observer.observe(this._pigNode, { childList: true });
				}
			}
		}
	}

	_getItemData(source, id) {
		let data = null;

		for (let index = 0; index < this._data.gallery.length; index++) {
			const photo = this._data.gallery[index];

			if (photo.source === source && photo.id === parseFloat(id)) {
				data = photo;

				break;
			}
		}

		return data;
	}

	_getRatio() {
		let ratio = this._props.source === "author" ? 3 : 2;

		if (CONFIG?.printMode === 3) {
			ratio = 5;
		} else {
			try {
				const storage = getItem("gallery-ratio");

				if (storage) {
					const obj = JSON.parse(storage);

					if (obj[this._type]) {
						ratio = obj[this._type];
					}
				}
			} catch (ex) {
				//chyba
			}
		}

		return ratio;
	}

	_buildStats(statsData) {
		const statsRow = node("div", { className: "stats-row" });

		statsRow.appendChild(buildStats(statsData));

		if (this._data.gallery.length > 2) {
			statsRow.appendChild(this._sorter.node);
		}

		const oldStatsRow = this._inner.querySelector("div.stats-row");

		if (oldStatsRow) {
			this._inner.replaceChild(statsRow, oldStatsRow);
		} else {
			this._inner.appendChild(statsRow);
		}
	}

	_setSEO() {
		const data = this._props.detail;
		let type = data && data.typeName ? ` (${data.typeName})` : "";

		if (data && data.typeName === _("detail.content.typename")) {
			type = "";
		}

		if (this._props.source === "author") {
			let title = `${_("gallery.titleAutor")} • ${this._props.title || ""}`;

			const { user } = store.getState().user;

			if (this._data && this._data.author && this._data.author.userPublicId === user.userPublicId) {
				title = _("gallery.titleMy");
			}

			this._respoBlock.innerText = title;
			Mapy.SEO.set(title, false, false, Mapy.getComponent("gallery"));

			Canonical.set("/", {
				source: this._props.source,
				id: this._props.id,
			});
		} else {
			const title = `${_("gallery.titlePhotos")} • ${this._props.title || ""}${type}`;

			this._respoBlock.innerText = title;
			Mapy.SEO.set(
				title,
				_("detail.seo", {
					title: this._props.title || "",
					type,
				}),
				false,
				Mapy.getComponent("gallery"),
			);

			Canonical.set("/", {
				source: this._props.source,
				id: this._props.id,
				gallery: 1,
			});
		}
	}

	_getLogData(data) {
		return {
			...this.logData,
			...{
				section: "gallery",
			},
			...data,
		};
	}

	_log(data, action = "click") {
		Mapy.getComponent("logger").log(action, this._getLogData(data));
	}
}
